import ApiFactory from '@/factories/ApiFactory'
import { serialize } from '@/utilities/querySerialize'

const getNotificationCategory = (type) => {
  type = type.toLowerCase();
  if (type === 'info') {
    return 'primary';
  }
  if (type === 'success') {
    return 'success';
  }
  if (type === 'error') {
    return 'danger';
  }
  if (type === 'warning') {
    return 'warning';
  }
  return 'primary';
};

const getNotificationIcon = (type) => {
  type = type.toLowerCase();
  if (type === 'info') {
    return 'MessageSquareIcon';
  }
  if (type === 'success') {
    return 'CheckIcon';
  }
  if (type === 'error') {
    return 'AlertCircleIcon';
  }
  if (type === 'warning') {
    return 'AlertTriangleIcon';
  }
  return 'MessageSquareIcon';
};
const getNotificationIconAndColor = (type) => {
  type = type.toLowerCase();
  if (type === 'info') {
    return {
      icon: 'icon-message-square',
      color: 'primary'
    };
  }
  if (type === 'success') {
    return {
      icon: 'icon-check',
      color: 'success',
    };
  }
  if (type === 'error') {
    return {
      icon: 'icon-alert-circle',
      color: 'danger'
    };
  }
  if (type === 'warning') {
    return {
      icon: 'icon-alert-triangle',
      color: 'warning'
    }
  }
  return {
    icon: 'icon-message-square',
    color: 'primary'
  }
};

const setIconAndCategory = (notifications) => {
  return notifications.map(n => {
    n.category = getNotificationCategory(n.type);
    n.icon = getNotificationIcon(n.type);
    return n;
  });
};

export default {
  list(query) {
    return new Promise((resolve, reject) => {
      ApiFactory.get(`v1/notifications?${serialize(query)}&include=roles`)
        .then(
          (success) => resolve(success.data),
          (error) => reject(error)
        )
    })
  },
  getUnreadNotifications () {
    return new Promise((resolve, reject) => {
      ApiFactory.get('v1/notifications?perPage=5&unread=true').then(({data}) => {
        resolve(setIconAndCategory(data.data));
      }, error => reject(error));
    });
  },
  markAsRead (notification) {
    return new Promise((resolve, reject) => {
      ApiFactory.put(`v1/notifications/${notification.id}/actions/markAsRead`).then(() => {
        resolve();
      }, error => reject(error));
    });
  },
  markAllAsRead () {
    return new Promise((resolve, reject) => {
      ApiFactory.put(`v1/notifications/actions/markAllAsRead`).then(() => {
        resolve();
      }, error => reject(error));
    });
  },
  manageRedirection(notification, vm) {
    if (notification.model_type === 'Timecard') {
      if (!notification.model_id) {
        vm.$router.push({name: 'approveTimecards'});
      }
    } else if (notification.model_type === 'MaintenancePayment') {
      vm.$router.push({name: 'maintenancePayments'});
    } else if (notification.model_type === 'Pto') {
      vm.$router.push({name: 'personalPTOs'});
    }
  },
  preparePushData(notification, vm) {
    let {title, message} = notification;
    if (!message) {
      message = title;
      if (notification.model_type === 'MaintenancePayment') {
        title = vm.$t('modules.maintenancePayments');
      }
    }
    const {icon, color} = getNotificationIconAndColor(notification.type);
    return {
      title,
      text: message,
      icon,
      color,
    };
  }
}
